var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"rows":this.projectData.files.map((i) => ({ name: i })),"pagination":false,"tableName":"projectFiles"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }